import { h, JSX } from 'preact';
import { useEffect, useRef } from 'preact/hooks';

export interface AutoSuggestProps {
    id?: string;
    name?: string;
    placeholder?: string;
    disabled?: boolean;
    serviceUrl: string;
    onInput?: () => void;
    onSelect?: (suggestion: AutocompleteSuggestion) => void; // Must not change on each render
}

export const AutoSuggest = (props: AutoSuggestProps): JSX.Element => {
    const { serviceUrl, onSelect } = props;
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (!inputRef) {
            return;
        }

        const input = $(inputRef.current);

        input.devbridgeAutocomplete({
            dataType: 'json',
            deferRequestBy: 300,
            groupBy: 'category',
            minChars: 1,
            serviceUrl,
            onSelect,
        });

        const autoComplete = input.autocomplete();

        return (): void => autoComplete.dispose();
    }, [inputRef, serviceUrl, onSelect]);

    return (
        <input
            ref={inputRef}
            type='text'
            class='block w-full h-12 py-3 transition duration-75 rounded-lg outline-none focus:border-primary-500 focus:ring-1 focus:ring-inset focus:ring-primary-500 disabled:opacity-70 border-gray-300'
            id={props.id}
            name={props.name}
            placeholder={props.placeholder}
            disabled={props.disabled}
            autocomplete='off'
            onInput={props.onInput}
        />
    );
};
